module.exports = require("dompurify");